import { useEffect, useState } from "react";

/**
 * Hook que devuelve un valor "atrasado" — se actualiza recién después de
 * `delayMs` ms sin cambios en `value`. Útil para no martillar al backend
 * con cada tecla del usuario en un campo de búsqueda.
 */
export function useDebounced<T>(value: T, delayMs: number): T {
  const [debounced, setDebounced] = useState(value);
  useEffect(() => {
    const t = setTimeout(() => setDebounced(value), delayMs);
    return () => clearTimeout(t);
  }, [value, delayMs]);
  return debounced;
}
